export const FURNITURE_TYPES = [
  { id: 'wardrobe', nameRu: 'Шкаф' },
  { id: 'table', nameRu: 'Стол' },
  { id: 'shelf', nameRu: 'Полка' },
  { id: 'bed', nameRu: 'Кровать' },
  { id: 'dresser', nameRu: 'Комод' },
  { id: 'bookcase', nameRu: 'Стеллаж' },
  { id: 'nightstand', nameRu: 'Тумба' },
  { id: 'kitchen_cabinet', nameRu: 'Кухонный шкаф' },
];

export const MODULE_DEFINITIONS = {
  wardrobe: [
    { type: 'body', nameRu: 'Корпус', defaultW: 120, defaultH: 200, defaultD: 60, basePrice: 5000 },
    { type: 'door', nameRu: 'Дверь', defaultW: 58, defaultH: 196, defaultD: 2, basePrice: 2000 },
    { type: 'shelf', nameRu: 'Полка', defaultW: 116, defaultH: 2, defaultD: 58, basePrice: 500 },
    { type: 'drawer', nameRu: 'Ящик', defaultW: 116, defaultH: 20, defaultD: 55, basePrice: 1500 },
    { type: 'hanging_rod', nameRu: 'Штанга', defaultW: 116, defaultH: 3, defaultD: 3, basePrice: 400 },
    { type: 'back_panel', nameRu: 'Задняя стенка', defaultW: 118, defaultH: 198, defaultD: 1, basePrice: 800 },
  ],
  table: [
    { type: 'tabletop', nameRu: 'Столешница', defaultW: 120, defaultH: 4, defaultD: 70, basePrice: 3000 },
    { type: 'leg', nameRu: 'Ножка', defaultW: 6, defaultH: 75, defaultD: 6, basePrice: 400 },
    { type: 'drawer', nameRu: 'Ящик', defaultW: 50, defaultH: 15, defaultD: 40, basePrice: 1200 },
    { type: 'crossbar', nameRu: 'Царга', defaultW: 108, defaultH: 8, defaultD: 3, basePrice: 600 },
  ],
  shelf: [
    { type: 'board', nameRu: 'Полка', defaultW: 80, defaultH: 3, defaultD: 25, basePrice: 400 },
    { type: 'bracket', nameRu: 'Кронштейн', defaultW: 3, defaultH: 20, defaultD: 25, basePrice: 200 },
    { type: 'back_panel', nameRu: 'Задняя стенка', defaultW: 78, defaultH: 18, defaultD: 1, basePrice: 300 },
  ],
  bed: [
    { type: 'headboard', nameRu: 'Изголовье', defaultW: 160, defaultH: 80, defaultD: 5, basePrice: 4500 },
    { type: 'frame', nameRu: 'Каркас', defaultW: 160, defaultH: 25, defaultD: 200, basePrice: 6000 },
    { type: 'leg', nameRu: 'Ножка', defaultW: 8, defaultH: 15, defaultD: 8, basePrice: 300 },
    { type: 'slat', nameRu: 'Ламель', defaultW: 140, defaultH: 2, defaultD: 8, basePrice: 150 },
  ],
  dresser: [
    { type: 'body', nameRu: 'Корпус', defaultW: 100, defaultH: 85, defaultD: 50, basePrice: 4000 },
    { type: 'drawer', nameRu: 'Ящик', defaultW: 96, defaultH: 18, defaultD: 48, basePrice: 1200 },
    { type: 'top_panel', nameRu: 'Столешница', defaultW: 100, defaultH: 3, defaultD: 50, basePrice: 1500 },
    { type: 'leg', nameRu: 'Ножка', defaultW: 5, defaultH: 10, defaultD: 5, basePrice: 200 },
  ],
  bookcase: [
    { type: 'body', nameRu: 'Корпус', defaultW: 80, defaultH: 200, defaultD: 30, basePrice: 4000 },
    { type: 'shelf', nameRu: 'Полка (во всю ширину)', defaultW: 76, defaultH: 2, defaultD: 28, basePrice: 400 },
    { type: 'shelf', nameRu: 'Полка в ячейку', defaultW: 35, defaultH: 2, defaultD: 28, basePrice: 250 },
    { type: 'shelf', nameRu: 'Перегородка (вертикальная)', defaultW: 2, defaultH: 35, defaultD: 28, basePrice: 300 },
    { type: 'drawer', nameRu: 'Ящик в ячейку', defaultW: 35, defaultH: 20, defaultD: 28, basePrice: 1200 },
    { type: 'drawer', nameRu: 'Ящик широкий', defaultW: 76, defaultH: 20, defaultD: 28, basePrice: 1500 },
    { type: 'hanging_rod', nameRu: 'Штанга (вешалка)', defaultW: 76, defaultH: 3, defaultD: 3, basePrice: 400 },
    { type: 'back_panel', nameRu: 'Задняя стенка', defaultW: 78, defaultH: 198, defaultD: 1, basePrice: 600 },
    { type: 'door', nameRu: 'Дверца', defaultW: 38, defaultH: 60, defaultD: 2, basePrice: 1800 },
  ],
  nightstand: [
    { type: 'body', nameRu: 'Корпус', defaultW: 50, defaultH: 55, defaultD: 40, basePrice: 2000 },
    { type: 'drawer', nameRu: 'Ящик', defaultW: 46, defaultH: 15, defaultD: 38, basePrice: 800 },
    { type: 'top_panel', nameRu: 'Столешница', defaultW: 50, defaultH: 2, defaultD: 40, basePrice: 600 },
    { type: 'leg', nameRu: 'Ножка', defaultW: 4, defaultH: 10, defaultD: 4, basePrice: 150 },
    { type: 'door', nameRu: 'Дверца', defaultW: 46, defaultH: 35, defaultD: 2, basePrice: 1000 },
  ],
  kitchen_cabinet: [
    { type: 'body', nameRu: 'Корпус', defaultW: 60, defaultH: 85, defaultD: 56, basePrice: 3500 },
    { type: 'door', nameRu: 'Фасад', defaultW: 56, defaultH: 72, defaultD: 2, basePrice: 2500 },
    { type: 'shelf', nameRu: 'Полка', defaultW: 56, defaultH: 2, defaultD: 54, basePrice: 500 },
    { type: 'drawer', nameRu: 'Ящик', defaultW: 56, defaultH: 15, defaultD: 50, basePrice: 1300 },
    { type: 'countertop', nameRu: 'Столешница', defaultW: 60, defaultH: 4, defaultD: 60, basePrice: 2000 },
  ],
};

export const MATERIALS = [
  { id: 'chipboard', nameRu: 'ДСП', pricePerSqm: 800, multiplier: 1.0 },
  { id: 'shelving_ldsp_16', nameRu: 'ЛДВП 16 мм (стеллажи)', pricePerSqm: 1100, multiplier: 1.15 },
  { id: 'shelving_ldsp_22', nameRu: 'ЛДВП 22 мм (стеллажи усиленные)', pricePerSqm: 1400, multiplier: 1.35 },
  { id: 'mdf', nameRu: 'МДФ', pricePerSqm: 1500, multiplier: 1.5 },
  { id: 'solid_wood', nameRu: 'Массив дерева', pricePerSqm: 4000, multiplier: 3.0 },
  { id: 'metal', nameRu: 'Металл', pricePerSqm: 3000, multiplier: 2.5 },
  { id: 'glass', nameRu: 'Стекло', pricePerSqm: 2500, multiplier: 2.0 },
];

export const COLORS = [
  { id: 'light_oak', nameRu: 'Дуб светлый', hex: '#C4A76C' },
  { id: 'dark_oak', nameRu: 'Дуб тёмный', hex: '#5C3D2E' },
  { id: 'walnut', nameRu: 'Орех', hex: '#5D4037' },
  { id: 'beech', nameRu: 'Бук', hex: '#C9B28A' },
  { id: 'wenge', nameRu: 'Венге', hex: '#3C2415' },
  { id: 'white', nameRu: 'Белый', hex: '#F5F5F0' },
  { id: 'black', nameRu: 'Чёрный', hex: '#2C2C2C' },
  { id: 'gray', nameRu: 'Серый', hex: '#9E9E9E' },
  { id: 'cherry', nameRu: 'Вишня', hex: '#7B3F00' },
  { id: 'maple', nameRu: 'Клён', hex: '#D4A574' },
];

export const HARDWARE = [
  { id: 'handle_classic', nameRu: 'Ручка классическая', type: 'handle', price: 350 },
  { id: 'handle_modern', nameRu: 'Ручка современная', type: 'handle', price: 500 },
  { id: 'handle_hidden', nameRu: 'Ручка скрытая', type: 'handle', price: 800 },
  { id: 'hinge_standard', nameRu: 'Петля обычная', type: 'hinge', price: 120 },
  { id: 'hinge_soft', nameRu: 'Петля с доводчиком', type: 'hinge', price: 350 },
  { id: 'slide_roller', nameRu: 'Направляющие роликовые', type: 'slide', price: 250 },
  { id: 'slide_ball', nameRu: 'Направляющие шариковые', type: 'slide', price: 600 },
];

export const getModuleZIndex = (type) => {
  const zMap = {
    back_panel: 5,
    body: 10,
    frame: 10,
    headboard: 10,
    shelf: 20,
    board: 20,
    hanging_rod: 20,
    slat: 20,
    crossbar: 20,
    countertop: 25,
    top_panel: 25,
    tabletop: 25,
    drawer: 30,
    bracket: 15,
    leg: 15,
    door: 40,
  };
  return zMap[type] || 20;
};

export const calculateModuleCost = (module) => {
  const material = MATERIALS.find(m => m.id === module.material) || MATERIALS[0];
  const baseCost = module.base_price || module.basePrice || 500;
  const materialCost = baseCost * material.multiplier;
  const hardwareCost = (module.hardware || []).reduce((sum, hwId) => {
    const hw = HARDWARE.find(h => h.id === hwId);
    return sum + (hw ? hw.price : 0);
  }, 0);
  return Math.round(materialCost + hardwareCost);
};

export const formatPrice = (price) => {
  return new Intl.NumberFormat('ru-RU').format(price) + ' \u20BD';
};

export const FILLING_PRESETS = [
  { id: 'empty', nameRu: 'Пустой', desc: 'Пустой корпус', modules: [] },
  { id: 'rod_top', nameRu: 'Штанга', desc: 'Штанга для одежды', modules: [
    { type: 'hanging_rod', relY: 0.12 },
    { type: 'shelf', relY: 0.17 },
  ]},
  { id: 'two_rods', nameRu: '2 штанги', desc: 'Верхняя и нижняя', modules: [
    { type: 'hanging_rod', relY: 0.10 },
    { type: 'shelf', relY: 0.47 },
    { type: 'hanging_rod', relY: 0.52 },
  ]},
  { id: 'shelves_only', nameRu: 'Полки', desc: '4 полки', modules: [
    { type: 'shelf', relY: 0.20 },
    { type: 'shelf', relY: 0.40 },
    { type: 'shelf', relY: 0.60 },
    { type: 'shelf', relY: 0.80 },
  ]},
  { id: 'rod_shelves', nameRu: 'Штанга + полки', desc: 'Комбинация', modules: [
    { type: 'hanging_rod', relY: 0.10 },
    { type: 'shelf', relY: 0.45 },
    { type: 'shelf', relY: 0.62 },
    { type: 'shelf', relY: 0.80 },
  ]},
  { id: 'shelves_drawers', nameRu: 'Полки + ящики', desc: '2 полки, 2 ящика', modules: [
    { type: 'shelf', relY: 0.25 },
    { type: 'shelf', relY: 0.48 },
    { type: 'drawer', relY: 0.64, relH: 0.13 },
    { type: 'drawer', relY: 0.79, relH: 0.13 },
  ]},
  { id: 'rod_shelves_drawers', nameRu: 'Штанга + полки + ящики', desc: 'Полный набор', modules: [
    { type: 'hanging_rod', relY: 0.10 },
    { type: 'shelf', relY: 0.42 },
    { type: 'drawer', relY: 0.56, relH: 0.12 },
    { type: 'drawer', relY: 0.70, relH: 0.12 },
    { type: 'drawer', relY: 0.84, relH: 0.12 },
  ]},
  { id: 'all_drawers', nameRu: 'Только ящики', desc: '6 ящиков', modules: [
    { type: 'drawer', relY: 0.04, relH: 0.13 },
    { type: 'drawer', relY: 0.19, relH: 0.13 },
    { type: 'drawer', relY: 0.34, relH: 0.13 },
    { type: 'drawer', relY: 0.49, relH: 0.13 },
    { type: 'drawer', relY: 0.64, relH: 0.13 },
    { type: 'drawer', relY: 0.79, relH: 0.13 },
  ]},
  { id: 'grid_2x2', nameRu: 'Сетка 2×2', desc: '4 открытые ячейки', grid: { cols: 2, rows: 2 } },
  { id: 'grid_2x3', nameRu: 'Сетка 2×3', desc: '6 открытых ячеек', grid: { cols: 2, rows: 3 } },
  { id: 'grid_3x3', nameRu: 'Сетка 3×3', desc: '9 открытых ячеек', grid: { cols: 3, rows: 3 } },
  { id: 'grid_3x4', nameRu: 'Сетка 3×4', desc: '12 открытых ячеек (KALLAX)', grid: { cols: 3, rows: 4 } },
  { id: 'grid_4x4', nameRu: 'Сетка 4×4', desc: '16 открытых ячеек', grid: { cols: 4, rows: 4 } },
  { id: 'grid_5x2', nameRu: 'Сетка 5×2', desc: 'Широкий стеллаж', grid: { cols: 5, rows: 2 } },
];

export const INTERNAL_MODULE_TYPES = ['shelf', 'drawer', 'hanging_rod', 'back_panel', 'board', 'slat', 'crossbar', 'bracket'];

export const BODY_MODULE_TYPES = ['body', 'frame', 'tabletop', 'headboard', 'countertop', 'top_panel'];

export const TEXTURE_URLS = {
  solid_wood: 'https://images.unsplash.com/photo-1708180841204-db34dc5c00af?w=512&h=512&fit=crop',
  chipboard: 'https://images.unsplash.com/photo-1732801134112-23827e7cbd0d?w=512&h=512&fit=crop',
  mdf: 'https://images.unsplash.com/photo-1732801134112-23827e7cbd0d?w=512&h=512&fit=crop',
  metal: 'https://images.unsplash.com/photo-1652005414507-d317208e3683?w=512&h=512&fit=crop',
  glass: 'https://images.unsplash.com/photo-1656536898449-43b7397fd2e9?w=512&h=512&fit=crop',
};

// ---------- Rotation-aware bbox ----------
export function getModuleBBox(mod) {
  const rot = ((mod.rotation || 0) % 360 + 360) % 360;
  const swap = rot === 90 || rot === 270;
  const w = swap ? mod.height : mod.width;
  const h = swap ? mod.width : mod.height;
  return { x1: mod.x, y1: mod.y, x2: mod.x + w, y2: mod.y + h, w, h };
}

// ---------- Collisions ----------
export function findBodyModule(modules) {
  return modules.find(m => BODY_MODULE_TYPES.includes(m.type)) || null;
}

function rectsOverlap(a, b) {
  return a.x1 < b.x2 && a.x2 > b.x1 && a.y1 < b.y2 && a.y2 > b.y1;
}

// True when two internal parts are allowed to share space on the 2D plan:
// — horizontal shelf crossing a vertical partition (both thin, perpendicular);
// — hanging rod with anything (rod is suspended inside, not blocking items);
// — back panel with anything (sits behind in depth axis).
function partsMayOverlap(a, b) {
  if (a.type === 'hanging_rod' || b.type === 'hanging_rod') return true;
  if (a.type === 'back_panel' || b.type === 'back_panel') return true;

  const isThinH = (m) => m.type === 'shelf' && m.height <= 5;
  const isThinV = (m) => m.type === 'shelf' && m.width <= 5;
  if ((isThinH(a) && isThinV(b)) || (isThinV(a) && isThinH(b))) return true;

  return false;
}

export function computeCollisions(modules) {
  const result = new Set();
  const body = findBodyModule(modules);
  const bodyBox = body ? getModuleBBox(body) : null;
  const internals = modules.filter(m => INTERNAL_MODULE_TYPES.includes(m.type) && m.type !== 'back_panel');

  modules.forEach(m => {
    if (BODY_MODULE_TYPES.includes(m.type)) return;
    const a = getModuleBBox(m);
    if (bodyBox && !BODY_MODULE_TYPES.includes(m.type)) {
      const inside = a.x1 >= bodyBox.x1 - 1 && a.y1 >= bodyBox.y1 - 1
        && a.x2 <= bodyBox.x2 + 1 && a.y2 <= bodyBox.y2 + 1;
      if (!inside) result.add(m.id);
    }
  });

  for (let i = 0; i < internals.length; i++) {
    for (let j = i + 1; j < internals.length; j++) {
      const a = getModuleBBox(internals[i]);
      const b = getModuleBBox(internals[j]);
      if (rectsOverlap(a, b) && !partsMayOverlap(internals[i], internals[j])) {
        result.add(internals[i].id);
        result.add(internals[j].id);
      }
    }
  }
  return result;
}

export function wouldCollide(moduleId, candidate, allModules) {
  const next = allModules.map(m => m.id === moduleId ? { ...m, ...candidate } : m);
  const coll = computeCollisions(next);
  return coll.has(moduleId);
}

// ---------- Snap + alignment guides ----------
const SNAP_THRESHOLD = 6;

export function computeSnapAndGuides(dragMod, others, proposedX, proposedY, snapEnabled) {
  const guides = [];
  let x = proposedX;
  let y = proposedY;
  const rot = ((dragMod.rotation || 0) % 360 + 360) % 360;
  const swap = rot === 90 || rot === 270;
  const w = swap ? dragMod.height : dragMod.width;
  const h = swap ? dragMod.width : dragMod.height;

  if (!snapEnabled) return { x, y, guides };

  const xCandidates = [];
  const yCandidates = [];
  others.forEach(o => {
    if (o.id === dragMod.id) return;
    const b = getModuleBBox(o);
    xCandidates.push({ pos: b.x1, label: 'left' });
    xCandidates.push({ pos: b.x2, label: 'right' });
    xCandidates.push({ pos: (b.x1 + b.x2) / 2, label: 'centerX' });
    yCandidates.push({ pos: b.y1, label: 'top' });
    yCandidates.push({ pos: b.y2, label: 'bottom' });
    yCandidates.push({ pos: (b.y1 + b.y2) / 2, label: 'centerY' });
  });

  const myEdgesX = [{ offset: 0 }, { offset: w }, { offset: w / 2 }];
  const myEdgesY = [{ offset: 0 }, { offset: h }, { offset: h / 2 }];

  let bestX = null;
  for (const e of myEdgesX) {
    for (const c of xCandidates) {
      const target = c.pos - e.offset;
      const dist = Math.abs(target - proposedX);
      if (dist < SNAP_THRESHOLD && (!bestX || dist < bestX.dist)) {
        bestX = { dist, pos: target, guideAt: c.pos };
      }
    }
  }
  let bestY = null;
  for (const e of myEdgesY) {
    for (const c of yCandidates) {
      const target = c.pos - e.offset;
      const dist = Math.abs(target - proposedY);
      if (dist < SNAP_THRESHOLD && (!bestY || dist < bestY.dist)) {
        bestY = { dist, pos: target, guideAt: c.pos };
      }
    }
  }

  if (bestX) { x = Math.round(bestX.pos); guides.push({ axis: 'x', at: bestX.guideAt }); }
  if (bestY) { y = Math.round(bestY.pos); guides.push({ axis: 'y', at: bestY.guideAt }); }

  return { x, y, guides };
}

// ---------- Parametric generators ----------
function genId() { return Math.random().toString(36).slice(2, 11); }

function makeModule(partial) {
  return {
    id: genId(),
    rotation: 0,
    material: 'chipboard',
    color_id: 'light_oak',
    color_hex: '#C4A76C',
    hardware: [],
    base_price: 500,
    ...partial,
  };
}

export function generateWardrobe({ width = 120, height = 200, depth = 60,
  doors = 2, shelves = 3, drawers = 0, rods = 1, color = 'light_oak', material = 'mdf' } = {}) {
  const c = COLORS.find(x => x.id === color) || COLORS[0];
  const base = { material, color_id: color, color_hex: c.hex };
  const mods = [];
  mods.push(makeModule({ ...base, type: 'body', name_ru: 'Корпус', width, height, depth, x: 0, y: 0, base_price: 5000 }));
  mods.push(makeModule({ ...base, type: 'back_panel', name_ru: 'Задняя стенка', width: width - 2, height: height - 2, depth: 1, x: 1, y: 1, base_price: 800 }));

  const doorW = Math.floor((width - 2 - (doors - 1) * 2) / doors);
  for (let i = 0; i < doors; i++) {
    mods.push(makeModule({
      ...base, type: 'door',
      name_ru: doors === 1 ? 'Дверь' : `Дверь ${i + 1}`,
      width: doorW, height: height - 4, depth: 2,
      x: 1 + i * (doorW + 2), y: 2,
      hardware: ['handle_modern', 'hinge_soft'], base_price: 2000,
    }));
  }

  const drawerH = 20;
  for (let i = 0; i < drawers; i++) {
    mods.push(makeModule({
      ...base, type: 'drawer', name_ru: `Ящик ${i + 1}`,
      width: width - 4, height: drawerH, depth: depth - 5,
      x: 2, y: height - 2 - (drawerH + 2) * (i + 1),
      hardware: ['handle_modern', 'slide_ball'], base_price: 1500,
    }));
  }

  const internalTop = 8;
  const drawerBandTop = drawers > 0 ? (height - 2 - (drawerH + 2) * drawers - 4) : height - 4;
  const availH = Math.max(20, drawerBandTop - internalTop);

  if (rods > 0) {
    const rodY = internalTop + 4;
    for (let i = 0; i < rods; i++) {
      mods.push(makeModule({
        ...base, material: 'metal', color_id: 'gray', color_hex: '#9E9E9E',
        type: 'hanging_rod', name_ru: rods === 1 ? 'Штанга' : `Штанга ${i + 1}`,
        width: width - 4, height: 3, depth: 3,
        x: 2, y: rodY + Math.round(availH * i / Math.max(1, rods)),
        base_price: 400,
      }));
    }
  }

  const shelvesStart = rods > 0 ? (internalTop + Math.round(availH * 0.5)) : internalTop + 5;
  const shelvesEnd = drawerBandTop - 5;
  const step = Math.max(15, Math.floor((shelvesEnd - shelvesStart) / Math.max(1, shelves + 1)));
  for (let i = 0; i < shelves; i++) {
    mods.push(makeModule({
      ...base, type: 'shelf', name_ru: `Полка ${i + 1}`,
      width: width - 4, height: 2, depth: depth - 2,
      x: 2, y: shelvesStart + step * (i + 1), base_price: 500,
    }));
  }
  return mods;
}

export function generateBookcase({ width = 80, height = 200, depth = 30,
  shelves = 5, cols = 1, rows = 0, hasBack = true, hasDoors = false,
  color = 'light_oak', material = 'shelving_ldsp_16' } = {}) {
  const c = COLORS.find(x => x.id === color) || COLORS[0];
  const base = { material, color_id: color, color_hex: c.hex };
  const mods = [];
  mods.push(makeModule({ ...base, type: 'body', name_ru: 'Корпус', width, height, depth, x: 0, y: 0, base_price: 4000 }));
  if (hasBack) {
    mods.push(makeModule({ ...base, type: 'back_panel', name_ru: 'Задняя стенка', width: width - 2, height: height - 2, depth: 1, x: 1, y: 1, base_price: 600 }));
  }

  const useGrid = cols > 1 || rows > 0;
  if (useGrid) {
    const rowsCount = rows > 0 ? rows : (shelves > 0 ? shelves + 1 : 1);
    const colsCount = Math.max(1, cols);
    const t = 2;
    const innerW = width - 4;
    const innerH = height - 4;
    const cellW = (innerW - (colsCount - 1) * t) / colsCount;
    const cellH = (innerH - (rowsCount - 1) * t) / rowsCount;
    for (let i = 1; i < colsCount; i++) {
      const x = 2 + i * (cellW + t) - t;
      mods.push(makeModule({
        ...base, type: 'shelf', name_ru: `Перегородка ${i}`,
        width: t, height: innerH, depth: depth - 2,
        x, y: 2, base_price: 450,
      }));
    }
    for (let j = 1; j < rowsCount; j++) {
      const y = 2 + j * (cellH + t) - t;
      mods.push(makeModule({
        ...base, type: 'shelf', name_ru: `Полка ${j}`,
        width: innerW, height: t, depth: depth - 2,
        x: 2, y, base_price: 400,
      }));
    }
  } else {
    const step = Math.floor((height - 10) / (shelves + 1));
    for (let i = 0; i < shelves; i++) {
      mods.push(makeModule({
        ...base, type: 'shelf', name_ru: `Полка ${i + 1}`,
        width: width - 4, height: 2, depth: depth - 2,
        x: 2, y: 5 + step * (i + 1), base_price: 400,
      }));
    }
  }

  if (hasDoors) {
    const doorH = Math.round(height * 0.35);
    mods.push(makeModule({
      ...base, type: 'door', name_ru: 'Дверца',
      width: width - 4, height: doorH, depth: 2,
      x: 2, y: height - doorH - 4,
      hardware: ['handle_modern', 'hinge_soft'], base_price: 1800,
    }));
  }
  return mods;
}

export function generateDresser({ width = 100, height = 85, depth = 50,
  drawers = 4, color = 'white', material = 'mdf' } = {}) {
  const c = COLORS.find(x => x.id === color) || COLORS[5];
  const base = { material, color_id: color, color_hex: c.hex };
  const mods = [];
  mods.push(makeModule({ ...base, type: 'body', name_ru: 'Корпус', width, height, depth, x: 0, y: 0, base_price: 4000 }));
  mods.push(makeModule({
    ...base, type: 'top_panel', name_ru: 'Столешница',
    width, height: 3, depth, x: 0, y: -3,
    material: 'solid_wood', color_id: 'walnut', color_hex: '#5D4037', base_price: 1500,
  }));
  const drH = Math.floor((height - (drawers + 1) * 2) / drawers);
  for (let i = 0; i < drawers; i++) {
    mods.push(makeModule({
      ...base, type: 'drawer', name_ru: `Ящик ${i + 1}`,
      width: width - 4, height: drH, depth: depth - 2,
      x: 2, y: 2 + (drH + 2) * i,
      hardware: ['handle_hidden', 'slide_ball'], base_price: 1200,
    }));
  }
  return mods;
}

export function generateKitchenCabinet({ width = 60, height = 85, depth = 56,
  doors = 1, shelves = 2, hasDrawer = false, color = 'white', material = 'mdf' } = {}) {
  const c = COLORS.find(x => x.id === color) || COLORS[5];
  const base = { material, color_id: color, color_hex: c.hex };
  const mods = [];
  mods.push(makeModule({ ...base, type: 'countertop', name_ru: 'Столешница',
    width, height: 4, depth: depth + 4, x: 0, y: 0,
    material: 'solid_wood', color_id: 'beech', color_hex: '#C9B28A', base_price: 2000 }));
  mods.push(makeModule({ ...base, type: 'body', name_ru: 'Корпус',
    width, height, depth, x: 0, y: 4, base_price: 3500 }));
  const doorW = Math.floor((width - 4 - (doors - 1) * 2) / doors);
  const doorY = 4 + (hasDrawer ? 18 : 3);
  const doorH = height - (hasDrawer ? 22 : 7);
  for (let i = 0; i < doors; i++) {
    mods.push(makeModule({
      ...base, type: 'door', name_ru: doors === 1 ? 'Фасад' : `Фасад ${i + 1}`,
      width: doorW, height: doorH, depth: 2,
      x: 2 + i * (doorW + 2), y: doorY,
      hardware: ['handle_modern', 'hinge_soft'], base_price: 2500,
    }));
  }
  if (hasDrawer) {
    mods.push(makeModule({
      ...base, type: 'drawer', name_ru: 'Ящик',
      width: width - 4, height: 14, depth: depth - 6,
      x: 2, y: 6,
      hardware: ['handle_modern', 'slide_ball'], base_price: 1300,
    }));
  }
  const step = Math.floor(doorH / (shelves + 1));
  for (let i = 0; i < shelves; i++) {
    mods.push(makeModule({
      ...base, type: 'shelf', name_ru: `Полка ${i + 1}`,
      width: width - 4, height: 2, depth: depth - 2,
      x: 2, y: doorY + step * (i + 1), base_price: 500,
    }));
  }
  return mods;
}

export function generateDesk({ width = 140, height = 75, depth = 70,
  drawers = 1, hasCrossbar = true, legStyle = 'four_legs',
  color = 'dark_oak', material = 'solid_wood' } = {}) {
  const c = COLORS.find(x => x.id === color) || COLORS[1];
  const base = { material, color_id: color, color_hex: c.hex };
  const metalBase = { material: 'metal', color_id: 'black', color_hex: '#2C2C2C' };
  const mods = [];

  const tabletopThickness = 4;
  mods.push(makeModule({ ...base, type: 'tabletop', name_ru: 'Столешница',
    width, height: tabletopThickness, depth, x: 0, y: 0, base_price: 3500 }));

  const legSize = 6;
  const legH = height - tabletopThickness;
  const legY = tabletopThickness;
  const edgeInset = 4;
  const apronH = 8;
  const apronY = legY + 2;

  if (legStyle === 'trestles') {
    mods.push(makeModule({
      ...base, ...metalBase,
      type: 'leg', name_ru: 'Боковина левая',
      width: 4, height: legH, depth: depth - 10,
      x: edgeInset, y: legY, z_pos: 5,
      base_price: 900,
    }));
    mods.push(makeModule({
      ...base, ...metalBase,
      type: 'leg', name_ru: 'Боковина правая',
      width: 4, height: legH, depth: depth - 10,
      x: width - edgeInset - 4, y: legY, z_pos: 5,
      base_price: 900,
    }));
    if (hasCrossbar) {
      mods.push(makeModule({
        ...base, ...metalBase,
        type: 'crossbar', name_ru: 'Стяжка',
        width: width - (edgeInset + 4) * 2, height: 6, depth: 3,
        x: edgeInset + 4, y: legY + legH - 12,
        z_pos: (depth - 3) / 2,
        base_price: 700,
      }));
    }
  } else {
    const legDefs = [
      { nameRu: 'Ножка передняя левая',   x: edgeInset, z: edgeInset },
      { nameRu: 'Ножка передняя правая',  x: width - edgeInset - legSize, z: edgeInset },
      { nameRu: 'Ножка задняя левая',     x: edgeInset, z: depth - edgeInset - legSize },
      { nameRu: 'Ножка задняя правая',    x: width - edgeInset - legSize, z: depth - edgeInset - legSize },
    ];
    legDefs.forEach(l => {
      mods.push(makeModule({
        ...base, ...metalBase,
        type: 'leg', name_ru: l.nameRu,
        width: legSize, height: legH, depth: legSize,
        x: l.x, y: legY, z_pos: l.z,
        base_price: 400,
      }));
    });

    if (hasCrossbar) {
      const frontApronX = edgeInset + legSize;
      const frontApronW = width - 2 * (edgeInset + legSize);
      const sideApronD = depth - 2 * (edgeInset + legSize);

      mods.push(makeModule({
        ...base, ...metalBase,
        type: 'crossbar', name_ru: 'Царга передняя',
        width: frontApronW, height: apronH, depth: 3,
        x: frontApronX, y: apronY, z_pos: edgeInset + 1,
        base_price: 600,
      }));
      mods.push(makeModule({
        ...base, ...metalBase,
        type: 'crossbar', name_ru: 'Царга задняя',
        width: frontApronW, height: apronH, depth: 3,
        x: frontApronX, y: apronY + apronH + 2, z_pos: depth - edgeInset - 4,
        base_price: 600,
      }));
      mods.push(makeModule({
        ...base, ...metalBase,
        type: 'crossbar', name_ru: 'Царга боковая левая',
        width: 3, height: apronH, depth: sideApronD,
        x: edgeInset + legSize, y: apronY,
        z_pos: edgeInset + legSize + sideApronD / 2,
        base_price: 500,
      }));
      mods.push(makeModule({
        ...base, ...metalBase,
        type: 'crossbar', name_ru: 'Царга боковая правая',
        width: 3, height: apronH, depth: sideApronD,
        x: width - edgeInset - legSize - 3, y: apronY,
        z_pos: edgeInset + legSize + sideApronD / 2,
        base_price: 500,
      }));
    }
  }

  if (drawers > 0) {
    const drawerH = 15;
    const drawerY = apronY + apronH + (legStyle === 'trestles' ? 0 : 12);
    const usableW = width - 2 * (edgeInset + legSize + 4);
    const gap = 4;
    const drawerW = Math.max(30, Math.floor((usableW - gap * (drawers - 1)) / drawers));
    const startX = edgeInset + legSize + 4;
    for (let i = 0; i < drawers; i++) {
      mods.push(makeModule({
        ...base, type: 'drawer', name_ru: drawers === 1 ? 'Ящик' : `Ящик ${i + 1}`,
        width: drawerW, height: drawerH, depth: Math.max(30, depth - 12),
        x: startX + i * (drawerW + gap), y: drawerY,
        z_pos: 6,
        hardware: ['handle_modern', 'slide_ball'], base_price: 1200,
      }));
    }
  }

  return mods;
}

export function generateBed({ width = 160, height = 25, depth = 200,
  hasHeadboard = true, color = 'dark_oak', material = 'solid_wood' } = {}) {
  const c = COLORS.find(x => x.id === color) || COLORS[1];
  const base = { material, color_id: color, color_hex: c.hex };
  const mods = [];
  const frameY = hasHeadboard ? 80 : 0;

  if (hasHeadboard) {
    mods.push(makeModule({ ...base, type: 'headboard', name_ru: 'Изголовье',
      width, height: 80, depth: 5, x: 0, y: 0, z_pos: 0, base_price: 4500 }));
  }
  mods.push(makeModule({ ...base, type: 'frame', name_ru: 'Каркас',
    width, height, depth, x: 0, y: frameY, base_price: 6000 }));

  const legSize = 8;
  const legH = 20;
  const legY = frameY + height;
  const edgeInset = 4;
  const backInsetX = Math.max(14, Math.round(depth / 18));

  const legDefs = [
    { nameRu: 'Ножка передняя левая',  x: edgeInset, z: edgeInset },
    { nameRu: 'Ножка передняя правая', x: width - edgeInset - legSize, z: edgeInset },
    { nameRu: 'Ножка задняя левая',    x: edgeInset + backInsetX, z: depth - edgeInset - legSize },
    { nameRu: 'Ножка задняя правая',   x: width - edgeInset - legSize - backInsetX, z: depth - edgeInset - legSize },
  ];
  legDefs.forEach(l => {
    mods.push(makeModule({
      ...base, type: 'leg', name_ru: l.nameRu,
      width: legSize, height: legH, depth: legSize,
      x: l.x, y: legY, z_pos: l.z,
      base_price: 300,
    }));
  });

  mods.push(makeModule({
    ...base, type: 'crossbar', name_ru: 'Центральная царга',
    width: 6, height: 8, depth: depth - 10,
    x: Math.round(width / 2) - 3, y: frameY + height - 10,
    z_pos: 5,
    base_price: 700,
  }));

  return mods;
}

export function generateNightstand({ width = 50, height = 55, depth = 40,
  drawers = 2, color = 'light_oak', material = 'mdf' } = {}) {
  const c = COLORS.find(x => x.id === color) || COLORS[0];
  const base = { material, color_id: color, color_hex: c.hex };
  const mods = [];
  mods.push(makeModule({ ...base, type: 'body', name_ru: 'Корпус', width, height, depth, x: 0, y: 0, base_price: 2000 }));
  mods.push(makeModule({ ...base, type: 'top_panel', name_ru: 'Столешница',
    width, height: 2, depth, x: 0, y: -2, base_price: 600 }));
  const drH = Math.floor((height - (drawers + 1) * 2) / drawers);
  for (let i = 0; i < drawers; i++) {
    mods.push(makeModule({
      ...base, type: 'drawer', name_ru: `Ящик ${i + 1}`,
      width: width - 4, height: drH, depth: depth - 2,
      x: 2, y: 2 + (drH + 2) * i,
      hardware: ['handle_modern', 'slide_ball'], base_price: 800,
    }));
  }
  return mods;
}

export function generateWallShelves({ count = 3, shelfWidth = 80, spacing = 30,
  depth = 25, color = 'walnut', material = 'solid_wood' } = {}) {
  const c = COLORS.find(x => x.id === color) || COLORS[2];
  const base = { material, color_id: color, color_hex: c.hex };
  const mods = [];
  for (let i = 0; i < count; i++) {
    mods.push(makeModule({
      ...base, type: 'board', name_ru: `Полка ${i + 1}`,
      width: shelfWidth, height: 3, depth,
      x: 0, y: i * (spacing + 3), base_price: 600,
    }));
    mods.push(makeModule({
      ...base, material: 'metal', color_id: 'black', color_hex: '#2C2C2C',
      type: 'bracket', name_ru: 'Кронштейн',
      width: 3, height: 20, depth, x: 8, y: i * (spacing + 3) + 3, base_price: 200,
    }));
    mods.push(makeModule({
      ...base, material: 'metal', color_id: 'black', color_hex: '#2C2C2C',
      type: 'bracket', name_ru: 'Кронштейн',
      width: 3, height: 20, depth, x: shelfWidth - 11, y: i * (spacing + 3) + 3, base_price: 200,
    }));
  }
  return mods;
}

// ---------- Local templates (5+ per category) ----------
const IMG = {
  wardrobe: 'https://images.unsplash.com/photo-1760072513442-9872656c1b07?w=800&h=600&fit=crop',
  table: 'https://images.unsplash.com/photo-1705321963943-de94bb3f0dd3?w=800&h=600&fit=crop',
  shelf: 'https://images.unsplash.com/photo-1732801134112-23827e7cbd0d?w=800&h=600&fit=crop',
  bed: 'https://images.unsplash.com/photo-1708180841204-db34dc5c00af?w=800&h=600&fit=crop',
  dresser: 'https://images.unsplash.com/photo-1652005414507-d317208e3683?w=800&h=600&fit=crop',
  bookcase: 'https://images.unsplash.com/photo-1595428774223-ef52624120d2?w=800&h=600&fit=crop',
  nightstand: 'https://images.unsplash.com/photo-1616046229478-9901c5536a45?w=800&h=600&fit=crop',
  kitchen_cabinet: 'https://images.unsplash.com/photo-1656536898449-43b7397fd2e9?w=800&h=600&fit=crop',
};

const TEMPLATE_IMAGES = {
  tpl_w_compact: 'https://images.unsplash.com/photo-1616594039964-3f77657bc4f7?w=800&h=600&fit=crop',
  tpl_w_classic: 'https://images.unsplash.com/photo-1616046229478-9901c5536a45?w=800&h=600&fit=crop',
  tpl_w_family: 'https://images.unsplash.com/photo-1616627547584-bf28cee262db?w=800&h=600&fit=crop',
  tpl_w_sliding: 'https://images.unsplash.com/photo-1616486338812-3dadae4b4ace?w=800&h=600&fit=crop',
  tpl_w_dark: 'https://images.unsplash.com/photo-1616593969747-4797dc75033e?w=800&h=600&fit=crop',
  tpl_w_mini: 'https://images.unsplash.com/photo-1556020685-ae41abfc9365?w=800&h=600&fit=crop',
};

function priceOf(modules) {
  return modules.reduce((s, m) => s + calculateModuleCost(m), 0);
}

function tpl(id, category, nameRu, description, modules) {
  return {
    id,
    name_ru: nameRu,
    category,
    description_ru: description,
    image: TEMPLATE_IMAGES[id] || IMG[category],
    modules,
    base_price: priceOf(modules),
  };
}

export const LOCAL_TEMPLATES = [
  tpl('tpl_w_compact', 'wardrobe', 'Компактный шкаф', 'Узкий однодверный шкаф для прихожей',
    generateWardrobe({ width: 80, height: 200, depth: 55, doors: 1, shelves: 2, drawers: 1, rods: 1 })),
  tpl('tpl_w_classic', 'wardrobe', 'Классический шкаф', 'Двухдверный шкаф с полками и штангой',
    generateWardrobe({ width: 120, height: 200, depth: 60, doors: 2, shelves: 3, drawers: 0, rods: 1, color: 'light_oak', material: 'mdf' })),
  tpl('tpl_w_family', 'wardrobe', 'Семейный шкаф', 'Трёхдверный с ящиками и штангой',
    generateWardrobe({ width: 180, height: 220, depth: 60, doors: 3, shelves: 4, drawers: 3, rods: 1 })),
  tpl('tpl_w_sliding', 'wardrobe', 'Купе светлый', 'Двухдверный шкаф-купе',
    generateWardrobe({ width: 160, height: 240, depth: 65, doors: 2, shelves: 2, drawers: 2, rods: 2, color: 'white', material: 'mdf' })),
  tpl('tpl_w_dark', 'wardrobe', 'Тёмный венге', 'Эффектный шкаф в тёмных тонах',
    generateWardrobe({ width: 140, height: 220, depth: 60, doors: 2, shelves: 4, drawers: 2, rods: 1, color: 'wenge', material: 'mdf' })),
  tpl('tpl_w_mini', 'wardrobe', 'Мини-шкаф', 'Небольшой шкаф для спальни',
    generateWardrobe({ width: 90, height: 180, depth: 50, doors: 2, shelves: 3, drawers: 1, rods: 1, color: 'beech' })),

  tpl('tpl_t_desk', 'table', 'Рабочий стол', 'Письменный стол с ящиком и царгами',
    generateDesk({ width: 140, height: 75, depth: 70, drawers: 1 })),
  tpl('tpl_t_dining', 'table', 'Обеденный стол', 'Просторный стол на 4 ножках',
    generateDesk({ width: 180, height: 75, depth: 90, drawers: 0, hasCrossbar: true, color: 'walnut' })),
  tpl('tpl_t_office', 'table', 'Офисный стол', 'Стол с двумя ящиками',
    generateDesk({ width: 160, height: 75, depth: 70, drawers: 2 })),
  tpl('tpl_t_compact', 'table', 'Компактный стол', 'Небольшой стол в кабинет',
    generateDesk({ width: 100, height: 75, depth: 60, drawers: 0, color: 'maple', material: 'chipboard' })),
  tpl('tpl_t_craft', 'table', 'Стол для творчества', 'Широкая столешница, 4 опоры',
    generateDesk({ width: 200, height: 80, depth: 80, drawers: 1, color: 'light_oak' })),
  tpl('tpl_t_trestle', 'table', 'Стол на боковинах', 'Современный стол на двух боковинах',
    generateDesk({ width: 160, height: 75, depth: 70, drawers: 0, legStyle: 'trestles', color: 'light_oak', material: 'solid_wood' })),
  tpl('tpl_t_bar', 'table', 'Барный стол', 'Высокий стол со стяжками',
    generateDesk({ width: 80, height: 105, depth: 60, drawers: 0, color: 'black' })),

  tpl('tpl_s_triple', 'shelf', 'Три полки', 'Настенный комплект из трёх полок',
    generateWallShelves({ count: 3, shelfWidth: 80, spacing: 30 })),
  tpl('tpl_s_five', 'shelf', 'Пять полок', 'Высокий комплект полок',
    generateWallShelves({ count: 5, shelfWidth: 90, spacing: 28 })),
  tpl('tpl_s_mini', 'shelf', 'Мини-полки', 'Две небольшие полки',
    generateWallShelves({ count: 2, shelfWidth: 60, spacing: 35, color: 'dark_oak' })),
  tpl('tpl_s_wide', 'shelf', 'Широкая полка', 'Одна длинная полка',
    generateWallShelves({ count: 1, shelfWidth: 120, depth: 30, color: 'light_oak' })),
  tpl('tpl_s_gallery', 'shelf', 'Галерея', 'Четыре полки для книг и декора',
    generateWallShelves({ count: 4, shelfWidth: 100, spacing: 32, color: 'walnut' })),

  tpl('tpl_b_single', 'bed', 'Односпальная кровать', 'Компактная кровать',
    generateBed({ width: 90, height: 25, depth: 190 })),
  tpl('tpl_b_double', 'bed', 'Двуспальная', 'Классическая двуспальная',
    generateBed({ width: 160, height: 25, depth: 200 })),
  tpl('tpl_b_king', 'bed', 'Кинг-сайз', 'Просторная кровать с изголовьем',
    generateBed({ width: 180, height: 30, depth: 210, color: 'walnut' })),
  tpl('tpl_b_no_head', 'bed', 'Без изголовья', 'Кровать-платформа',
    generateBed({ width: 160, height: 25, depth: 200, hasHeadboard: false, color: 'light_oak' })),
  tpl('tpl_b_modern', 'bed', 'Современная кровать', 'Тёмная с низким профилем',
    generateBed({ width: 180, height: 22, depth: 210, color: 'black', material: 'mdf' })),

  tpl('tpl_d_classic', 'dresser', 'Классический комод', 'Белый с четырьмя ящиками',
    generateDresser({ width: 100, height: 85, depth: 50, drawers: 4, color: 'white', material: 'mdf' })),
  tpl('tpl_d_tall', 'dresser', 'Высокий комод', '6 ящиков',
    generateDresser({ width: 80, height: 140, depth: 45, drawers: 6 })),
  tpl('tpl_d_wide', 'dresser', 'Широкий комод', '3 больших ящика',
    generateDresser({ width: 140, height: 80, depth: 50, drawers: 3, color: 'light_oak' })),
  tpl('tpl_d_dark', 'dresser', 'Тёмный комод', 'Массив ореха',
    generateDresser({ width: 120, height: 90, depth: 50, drawers: 5, color: 'walnut', material: 'solid_wood' })),
  tpl('tpl_d_mini', 'dresser', 'Мини-комод', 'Компактный на 3 ящика',
    generateDresser({ width: 60, height: 75, depth: 40, drawers: 3, color: 'beech' })),

  tpl('tpl_bc_slim', 'bookcase', 'Узкий стеллаж', '5 полок',
    generateBookcase({ width: 60, height: 200, depth: 30, shelves: 5 })),
  tpl('tpl_bc_wide', 'bookcase', 'Широкий стеллаж', '6 полок',
    generateBookcase({ width: 120, height: 220, depth: 35, shelves: 6, color: 'walnut' })),
  tpl('tpl_bc_library', 'bookcase', 'Библиотека', 'С дверцей внизу',
    generateBookcase({ width: 100, height: 240, depth: 35, shelves: 7, hasDoors: true, color: 'dark_oak' })),
  tpl('tpl_bc_low', 'bookcase', 'Низкий стеллаж', '3 полки',
    generateBookcase({ width: 100, height: 100, depth: 30, shelves: 3, color: 'white', material: 'mdf' })),
  tpl('tpl_bc_kids', 'bookcase', 'Детский стеллаж', '4 полки, светлый',
    generateBookcase({ width: 80, height: 140, depth: 28, shelves: 4, color: 'maple' })),
  tpl('tpl_bc_grid_2x2', 'bookcase', 'Сетка 2×2', 'Кубический стеллаж на 4 ячейки',
    generateBookcase({ width: 80, height: 80, depth: 35, cols: 2, rows: 2, material: 'shelving_ldsp_16' })),
  tpl('tpl_bc_grid_3x3', 'bookcase', 'Сетка 3×3', 'Стеллаж KALLAX 3×3',
    generateBookcase({ width: 115, height: 115, depth: 35, cols: 3, rows: 3, material: 'shelving_ldsp_22' })),
  tpl('tpl_bc_grid_3x4', 'bookcase', 'Сетка 3×4', 'Стеллаж KALLAX 3×4',
    generateBookcase({ width: 115, height: 150, depth: 35, cols: 3, rows: 4, material: 'shelving_ldsp_22', color: 'light_oak' })),
  tpl('tpl_bc_grid_4x4', 'bookcase', 'Сетка 4×4', 'Просторный стеллаж на 16 ячеек',
    generateBookcase({ width: 150, height: 150, depth: 38, cols: 4, rows: 4, material: 'shelving_ldsp_22', color: 'white' })),
  tpl('tpl_bc_grid_5x2', 'bookcase', 'Широкий 5×2', 'Низкий горизонтальный стеллаж',
    generateBookcase({ width: 180, height: 75, depth: 38, cols: 5, rows: 2, material: 'shelving_ldsp_16', color: 'walnut' })),

  tpl('tpl_n_classic', 'nightstand', 'Классическая тумба', '2 ящика',
    generateNightstand({ width: 50, height: 55, depth: 40, drawers: 2 })),
  tpl('tpl_n_single', 'nightstand', 'Тумба с ящиком', '1 ящик',
    generateNightstand({ width: 45, height: 45, depth: 38, drawers: 1, color: 'white', material: 'mdf' })),
  tpl('tpl_n_tall', 'nightstand', 'Высокая тумба', '3 ящика',
    generateNightstand({ width: 55, height: 80, depth: 45, drawers: 3, color: 'walnut' })),
  tpl('tpl_n_wide', 'nightstand', 'Широкая тумба', '2 больших ящика',
    generateNightstand({ width: 80, height: 50, depth: 45, drawers: 2, color: 'dark_oak' })),
  tpl('tpl_n_modern', 'nightstand', 'Современная тумба', 'Чёрная минималистичная',
    generateNightstand({ width: 50, height: 50, depth: 40, drawers: 2, color: 'black', material: 'mdf' })),

  tpl('tpl_k_base', 'kitchen_cabinet', 'Напольный шкаф', 'Базовый модуль 60 см',
    generateKitchenCabinet({ width: 60, height: 85, depth: 56, doors: 1, shelves: 2, hasDrawer: true })),
  tpl('tpl_k_wide', 'kitchen_cabinet', 'Широкий шкаф', '80 см, 2 фасада',
    generateKitchenCabinet({ width: 80, height: 85, depth: 56, doors: 2, shelves: 2 })),
  tpl('tpl_k_tall', 'kitchen_cabinet', 'Колонна', 'Высокий пенал',
    generateKitchenCabinet({ width: 60, height: 200, depth: 56, doors: 2, shelves: 5 })),
  tpl('tpl_k_dark', 'kitchen_cabinet', 'Тёмный фасад', 'С чёрным фасадом',
    generateKitchenCabinet({ width: 60, height: 85, depth: 56, doors: 1, shelves: 2, color: 'black', material: 'mdf' })),
  tpl('tpl_k_drawers', 'kitchen_cabinet', 'Комод-шкаф', 'С ящиком и фасадом',
    generateKitchenCabinet({ width: 80, height: 85, depth: 56, doors: 2, shelves: 1, hasDrawer: true, color: 'light_oak' })),
];

export function getTemplatesByCategory(category) {
  return LOCAL_TEMPLATES.filter(t => t.category === category);
}

export function cloneTemplateModules(tplItem) {
  return tplItem.modules.map(m => ({ ...m, id: genId() }));
}
